"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.Heading = void 0;

var _react = _interopRequireDefault(require("react"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var Heading = function Heading(props) {
  return _react["default"].createElement(_Text["default"], props);
};

exports.Heading = Heading;
Heading.defaultProps = {
  lineHeight: "1.2",
  fontFamily: "sansSerif",
  fontWeight: "300",
  fontSize: 9,
  letterSpacing: "-0.0083rem",
  as: "h2",
  m: 0
};

var H1 = function H1(props) {
  return _react["default"].createElement(Heading, props);
};

exports.H1 = H1;
H1.defaultProps = {
  fontSize: 10,
  letterSpacing: "-0.015625rem",
  as: "h1"
};
var H2 = Heading;
exports.H2 = H2;

var H3 = function H3(props) {
  return _react["default"].createElement(Heading, props);
};

exports.H3 = H3;
H3.defaultProps = {
  fontSize: 8,
  letterSpacing: "0rem",
  fontWeight: "400",
  as: "h3"
};

var H4 = function H4(props) {
  return _react["default"].createElement(Heading, props);
};

exports.H4 = H4;
H4.defaultProps = {
  fontSize: 7,
  letterSpacing: "0.007rem",
  fontWeight: "400",
  as: "h4"
};